{
  "id": "001-008",
  "title": "Thinking with portals",
  "layout": {
    "offset": "odd-row",
    "tiles": {
      "0": {
        "1": {
          "id": "744fba7a",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 3
                }
              ],
              "id": "b890e470"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "110796b4"
            }
          ]
        },
        "2": {
          "id": "70dbb697",
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "id": "979a9e6d"
            }
          ]
        },
        "3": {
          "id": "02825cfd",
          "type": "tile",
          "items": [
            {
              "type": "reflector",
              "id": "3af37e59"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "3db9b817"
            }
          ]
        },
        "-1": {
          "id": "611a4233",
          "type": "tile"
        },
        "-2": {
          "id": "8a2041c5",
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "id": "021b4ba2"
            }
          ]
        },
        "-3": {
          "id": "63af4b07",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#008000",
                  "direction": 1,
                  "toggled": true
                }
              ],
              "id": "7ab05f54"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "1f98dd59"
            }
          ]
        }
      },
      "1": {
        "1": {
          "id": "42aa42df",
          "type": "tile",
          "modifiers": [
            {
              "type": "immutable",
              "id": "7bf21678"
            }
          ]
        },
        "2": {
          "id": "dbaeb3de",
          "type": "tile"
        },
        "-2": {
          "id": "19a43886",
          "type": "tile"
        },
        "-3": {
          "id": "26bc177a",
          "type": "tile"
        }
      },
      "-1": {
        "1": {
          "id": "51c0929a",
          "type": "tile"
        },
        "2": {
          "id": "46963c5c",
          "type": "tile"
        },
        "-3": {
          "id": "e21f9280",
          "type": "tile"
        },
        "-2": {
          "id": "55a0cecf",
          "type": "tile"
        }
      }
    },
    "modifiers": [
      {
        "type": "move",
        "id": "845596b7"
      }
    ]
  },
  "requirements": [
    {
      "type": "connections",
      "amount": 1
    }
  ],
  "version": 0
}
